import { render } from "./ModelEditor.vue?vue&type=template&id=7c87faa4&scoped=true"
import script from "./ModelEditor.vue?vue&type=script&lang=js"
export * from "./ModelEditor.vue?vue&type=script&lang=js"

import "./ModelEditor.vue?vue&type=style&index=0&id=7c87faa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c87faa4"]])

export default __exports__